import React from 'react';
import Chapter from '../components/Chapter';
import Scenario from '../components/Scenario';
import Text from '../components/Text';
import Box from '../components/Box';

const Chapter1 = ({
  id,
  trackEvent,
}) => (
  <Chapter
    id={id}
    theme="green"
    title="07:00 uur, maandag"
    onEnter={() => trackEvent(id)}
  >
    <Text>Je hebt een afspraak, pakt je telefoon en checkt je score: 600. Een prima gemiddelde, want 300 is het laagst, hoger dan 900 kan niet.</Text>
    <Scenario
      id="1"
      title="Wat doe je?"
      description="Je hebt haast en het stoplicht staat op rood. Er komt geen verkeer aan."
      scoreFirst={0}
      scoreSecond={-60}
      buttonTextFirst="Wachten op groen"
      buttonTextSecond="Oversteken"
      resultTextFirst="Zo hoort het. Jouw score blijft 600."
      resultTextSecond="Een camera ziet je door rood gaan. Je gezicht wordt herkend. Vijf keer een rood licht negeren betekent dat je op de zwarte lijst komt te staan."
      onCallback={(title, choice) => trackEvent(id, choice)}
    />
    <Box>
      <h3>Pilots</h3>
      <Text>Op dit moment test China in meerdere regio’s de Social Credit Score. Je krijgt minpunten als je je niet aan de regels houdt, bonuspunten als je iets goeds doet, zoals doneren aan goede doelen.</Text>
      <Text>Een paar bedrijven werken aan soortgelijke systemen. Het bekendste: Sesame Credit van Alibaba, dat is een van de grootste bedrijven van China.</Text>
    </Box>
  </Chapter>
);

export default Chapter1;



// WEBPACK FOOTER //
// ./src/chapters/Chapter1.js